import { render, staticRenderFns } from "./Apprenants.vue?vue&type=template&id=21cca7d2&scoped=true&"
import script from "./Apprenants.vue?vue&type=script&lang=js&"
export * from "./Apprenants.vue?vue&type=script&lang=js&"
import style0 from "./Apprenants.vue?vue&type=style&index=0&id=21cca7d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cca7d2",
  null
  
)

export default component.exports